import React from 'react';

import styles from './loadText.module.css';



/**
 * @param {Object} props
 * @param {boolean} [props.dark = true] Use dark or light mode
 * @param {number} [props.max = 85] Max width
 * @param {number} [props.min = 20] Min width
 * @param {string|null} [props.width = null] Width, overwrites max and min
 * @param {string|null} [props.height = '0.8em'] Width, overwrites max and min
 * @param {number} [props.strength = 1] Strength of the effect
 */
export const LoadText = ({ dark = true, max = 85, min = 20, strength = 1, height = '0.8em', width = null }) => {
    return <div className={styles.LoadText + (!dark ? ' ' + styles.Light : '')} style={{
        // @ts-ignore
        '--width': width ? width : Math.round(Math.random() * (max - min) + min) + '%',
        // @ts-ignore
        '--strength': strength,
        // @ts-ignore
        '--height': height
    }}></div>
}